import { IWorkerHistoryItem } from '../../../../../../modules/API/Workers/models/workerHistory'
import { lightTheme } from '../../../../../../../styles/theme'

const HISTORY_TIME_ZONE = 'Asia/Jerusalem'
const UNASSIGNED_WORKER_LABEL = 'לא משויך'
const FALLBACK_ACTION_COLOR = lightTheme.colors.ink3

const ACTION_VIEW: Record<string, { label: string; color: string }> = {
  '+': { label: 'שיוך', color: lightTheme.colors.success },
  '-': { label: 'ביטול שיוך', color: lightTheme.colors.danger },
}

export interface IWorkerHistoryDateTime {
  date: string
  time: string
}

export interface IWorkerHistoryRowView {
  dateTime: IWorkerHistoryDateTime | null
  actionLabel: string
  actionColor: string
  fromWorkerLabel: string
  toWorkerLabel: string
  pickupOrderLabel: string | null
  userLabel: string
}

export const formatHistoryDateTime = (isoString: string): IWorkerHistoryDateTime | null => {
  const parsed = new Date(isoString)
  if (Number.isNaN(parsed.getTime())) return null

  // Fixed warehouse timezone so the label doesn't drift with the device TZ.
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: HISTORY_TIME_ZONE,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(parsed)
  const part = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((p) => p.type === type)?.value ?? ''

  return {
    date: `${part('day')}/${part('month')}/${part('year')}`,
    time: `${part('hour')}:${part('minute')}`,
  }
}

const workerLabel = (workerID: number, workerName: string) =>
  workerID === 0 ? UNASSIGNED_WORKER_LABEL : workerName.trim()

export const buildWorkerHistoryRowView = (item: IWorkerHistoryItem): IWorkerHistoryRowView => {
  const action = ACTION_VIEW[item.action]

  return {
    dateTime: formatHistoryDateTime(item.changed_at),
    actionLabel: action?.label ?? item.action,
    actionColor: action?.color ?? FALLBACK_ACTION_COLOR,
    fromWorkerLabel: workerLabel(item.fromWorkerID, item.fromWorkerName),
    toWorkerLabel: workerLabel(item.toWorkerID, item.toWorkerName),
    pickupOrderLabel:
      item.fromPickupOrder === item.toPickupOrder
        ? null
        : `${item.fromPickupOrder} → ${item.toPickupOrder}`,
    userLabel: item.user.trim(),
  }
}
